/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext } from 'react';

import { StaticImage } from 'gatsby-plugin-image';
import { Link, navigate } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping, faPlusCircle, faUsers, faBookmark, faHouse, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@gatsbyjs/reach-router';
import Dropdown from '../Dropdown';
import Button from '../Button';
import UserContext from '../../context/userContext';
import { getCookie, clearCookie } from '../../helpers/common';

function Header() {
  const location = useLocation();
  const [showIcons] = useState(location?.pathname !== '/');
  const { user, setUser } = useContext(UserContext);
  const currentProfileId = getCookie('current_profile') || user?._id;

  const onLogout = () => {
    setUser(null);
    clearCookie('current_profile');
    clearCookie('itombs_token');
    clearCookie('itombs_sessionID');
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.removeItem('itombs_profile');
    }
    navigate('/user/login');
  };

  return (
    <div className="header">
      <div className="container">
        <div className="logo">
          <a href="/user/feed">
            <StaticImage src="../../images/logo.png" alt="img description" />
          </a>
        </div>
        {showIcons && user ? (
          <div className="icon-holder">
            <Link to="/user/feed">
              <div className="icon">
                <FontAwesomeIcon icon={faHouse} /> <span>Home</span>
              </div>
            </Link>
            <Link to={`/user/profile?id=${currentProfileId}&saved=${true}`}>
              <div className="icon icon-favourite">
                <FontAwesomeIcon icon={faBookmark} /> <span>Saved Posts</span>
              </div>
            </Link>
            <Link href="/user/create-post">
              <div className="icon">
                <FontAwesomeIcon icon={faPlusCircle} /> <span>Create Post</span>
              </div>
            </Link>
            <Link to="/user/choose-profile" id="follower-list-icon" className="follower-icon">
              <div className="icon">
                <FontAwesomeIcon icon={faUsers} /> <span>Change Profile</span>
              </div>
            </Link>
            <Dropdown />
            <Link href="https://itombs.net/shop" target="_blank">
              <div className="icon">
                <FontAwesomeIcon icon={faCartShopping} /> <span>Shop</span>
              </div>
            </Link>
            <div className="icon header-logout" onClick={onLogout} role="button" tabIndex={0} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onLogout(); } }}>
              <FontAwesomeIcon icon={faRightFromBracket} /> <span>Logout</span>
            </div>
          </div>
        ) : (
          <div className="btn-login">
            <Button
              variant="primary"
              onClick={() => {
                navigate('/user/login');
              }}>
              <StaticImage className="ico" src="../../images/ico-user.svg" alt="img description" />
              Login
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
